// source: https://github.com/aaronpk/pkce-vanilla-js/blob/7d62773940956e95edd79eb96cc4b44a9d06800e/index.html#L159
// Generate a secure random string using the browser crypto functions
export function generateRandomString(): string {
  const array = new Uint32Array(28);
  crypto.getRandomValues(array);
  return Array.from(array, (dec) => `0${dec.toString(16)}`.substr(-2)).join('');
}

// Calculate the SHA256 hash of the input text.
// Returns a promise that resolves to an ArrayBuffer
export function sha256(plain: string) {
  const encoder = new TextEncoder();
  const data = encoder.encode(plain);
  return crypto.subtle.digest('SHA-256', data);
}

// Base64-urlencodes the input string
export function base64urlencode(str: ArrayBuffer) {
  // Convert the ArrayBuffer to string using Uint8 array to conver to what btoa accepts.
  // btoa accepts chars only within ascii 0-255 and base64 encodes them.
  // Then convert the base64 encoded to base64url encoded
  //   (replace + with -, replace / with _, trim trailing =)
  // FIXME: unclear if this cast is safe. For some reason Uint8Array is not number[]
  return btoa(String.fromCharCode.apply(null, new Uint8Array(str) as unknown as number[]))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
}

// Return the base64-urlencoded sha256 hash for the PKCE challenge
export async function pkceChallengeFromVerifier(v: string) {
  const hashed = await sha256(v);
  return base64urlencode(hashed);
}

export function buildUrlWithQueryParameters(baseUrl: string, parameters: Record<string, string>) {
  return Object.entries(parameters).reduce((acc, current, index) => {
    const [key, value] = current;
    const separator = index === 0 ? '?' : '&';
    return `${acc}${separator}${key}=${value}`;
  }, `${baseUrl}`);
}
